export const NativeHapticFeedback = () => { };
